import { Injectable } from '@angular/core';
import { AppSettings } from '../config/settings/app-settings';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class sessionServices{
	public sessionKey : string = "";
	public sessionObject : any = {
		'sessionStarted'  : "false",
		'sessionConName' : "",
		'sessionRegion'  : "",
		'sessionEmail'  : "",
		'cosumerZone' : "",
		'sessionId'  : "",
		'consumerId' : "",
		'credChange' : "",
		'sessionMobile'  : ""
	};
	
	constructor() {}
	
	
	
	getSessionDetails = function(){
		this.sessionKey = window.sessionStorage.getItem('sessionKey');
		if(this.sessionKey && this.sessionKey != ''){
			var key =  AppSettings.SEC_KEY_ID_1;
			var iv = AppSettings.SEC_KEY_ID_2;
			var decrypted:any = CryptoJS.AES.decrypt(this.sessionKey, key , {iv: iv});
			decrypted = decrypted.toString(CryptoJS.enc.Utf8);
			decrypted = decrypted.split("!^@#");
			//decrypted = decrypted[0].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.sessionStarted = decrypted[0].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.sessionConName = decrypted[1].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.sessionEmail = decrypted[2].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.sessionRegion = decrypted[3].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.cosumerZone = decrypted[4].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.consumerId = decrypted[5].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.sessionId = decrypted[5].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.credChange = decrypted[6].substring((AppSettings.SEC_KEY_ID_1).length);
			this.sessionObject.sessionMobile = decrypted[7].substring((AppSettings.SEC_KEY_ID_1).length);
		}
		
		return this.sessionObject;
	}
	
	isLoggedIn = function(){
		if(this.sessionObject.sessionStarted == 'true'){
			return true;
		}else{
			return false;
		}
	}

	
 
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/services/session.services.ts